<template>
    <div v-if="showCourseAsk" class="floatingBtn">
        <a
            :href="$store.state.courseAskUrl"
            target="_blank"
            rel="noopener"
            class="course-line-link btn btn-primary shadow-sm"
            aria-label="開啟 LINE 課程詢問（另開新視窗）"
        >
            <img class="course-line-icon" src="@/assets/svg/line.svg" alt="">
            <p class="course-line-label mb-0 mt-1 font-weight-bolder text-center">
                課程詢問
            </p>
        </a>
    </div>
</template>

<script>
import { CAMP_ROUTE_NAMES } from '@/utils/campRouteNames';

export default {
    name: 'FloatingBtn',
    computed: {
        showCourseAsk() {
            // 營隊相關 route 一律不顯示，改由 CampFloatingBtn 顯示營隊自己的官方 LINE 詢問連結。
            return !!this.$store.state.courseAskUrl && !CAMP_ROUTE_NAMES.includes(this.$route.name);
        },
    },
};
</script>

<style lang="scss" scoped>
.floatingBtn {
    position: fixed;
    top: 450px;
    right: 0;
    z-index: 1030;

    p {
        font-size: 12px;
        letter-spacing: 1px;
    }
}

@media (max-width: 767.98px) {
    .floatingBtn {
        top: 65%;
        transform: translateY(-50%);

        .course-line-link {
            display: flex;
            width: 44px;
            min-height: 96px;
            padding: 8px 0;
            align-items: center;
            justify-content: center;
            border-radius: 8px 0 0 8px;
        }

        .course-line-icon {
            display: none;
        }

        .course-line-label {
            margin-top: 0 !important;
            font-size: 15px;
            line-height: 1.35;
            letter-spacing: 2px;
            writing-mode: vertical-rl;
            text-orientation: upright;
        }
    }
}
</style>
